var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25918 4.00001C4.64957 4 4.15538 4.49419 4.15538 5.10381V7.1983H2.1038C1.49419 7.1983 1 7.69248 1 8.30209V18.8962C1 19.5058 1.49419 20 2.1038 20H18.8187C19.4283 20 19.9225 19.5058 19.9225 18.8962V16.7996H21.9722C22.5818 16.7996 23.076 16.3054 23.076 15.6958V5.10392C23.076 4.49432 22.5818 4.00013 21.9722 4.00013L5.25918 4.00001ZM5.19556 5.4961C5.19555 5.25225 5.39323 5.05456 5.63708 5.05456H21.5962C21.84 5.05456 22.0377 5.25223 22.0377 5.49608V15.3035C22.0377 15.5473 21.84 15.745 21.5962 15.745H19.9225V8.30192C19.9225 7.6923 19.4283 7.19812 18.8187 7.19812H5.19563L5.19556 5.4961ZM2.04015 8.69647C2.04016 8.45263 2.23783 8.25496 2.48167 8.25496H4.15538V8.25706H18.4385C18.6823 8.25706 18.88 8.45474 18.88 8.69858V16.7999H18.8821V18.5104C18.8821 18.7542 18.6844 18.9519 18.4406 18.9519H2.48146C2.23761 18.9519 2.03994 18.7542 2.03994 18.5104L2.04015 8.69647Z",
    fill: "#0067E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4656 16.1415C15.3431 16.1415 15.2294 16.0781 15.1651 15.9739L13.7333 13.6547C13.7075 13.6129 13.6938 13.5647 13.6938 13.5156V13.4339C13.6938 13.3327 13.7759 13.2506 13.8771 13.2506V13.2506C14.3215 13.2506 14.6603 13.1914 14.8936 13.0729C15.1325 12.9543 15.2713 12.7405 15.3102 12.4313H13.9412C13.8046 12.4313 13.6938 12.3206 13.6938 12.184V12.184C13.6938 12.0473 13.8046 11.9366 13.9412 11.9366H15.3019C15.2463 11.648 15.0991 11.4393 14.8603 11.3105C14.627 11.1817 14.2993 11.1173 13.8771 11.1173V11.1173C13.7759 11.1173 13.6938 11.0352 13.6938 10.934V10.8699C13.6938 10.7333 13.8046 10.6226 13.9412 10.6226H16.8959C17.0325 10.6226 17.1432 10.7333 17.1432 10.8699V10.8699C17.1432 11.0065 17.0325 11.1173 16.8959 11.1173H15.5685C15.8351 11.3182 15.9934 11.5913 16.0434 11.9366H16.8959C17.0325 11.9366 17.1432 12.0473 17.1432 12.184V12.184C17.1432 12.3206 17.0325 12.4313 16.8959 12.4313H16.0601C16.0212 12.8075 15.8657 13.1012 15.5935 13.3125C15.3269 13.5186 14.9714 13.65 14.527 13.7067L15.7613 15.5951C15.9148 15.83 15.7462 16.1415 15.4656 16.1415V16.1415Z",
    fill: "#0067E2",
    stroke: "#0067E2",
    strokeWidth: 0.22076
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 6.5,
    height: 0.8,
    rx: 0.4,
    fill: "#0067E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 13,
    width: 2.8,
    height: 0.8,
    rx: 0.4,
    fill: "#0067E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 2.8,
    height: 0.8,
    rx: 0.4,
    fill: "#0067E2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7002,
    y: 13,
    width: 2.8,
    height: 0.8,
    rx: 0.4,
    fill: "#0067E2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.7002,
    y: 15,
    width: 2.8,
    height: 0.8,
    rx: 0.4,
    fill: "#0067E2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdc);
export default __webpack_public_path__ + "static/media/pdc.0898d4698668d96fc13909f2c3853a8d.svg";
export { ForwardRef as ReactComponent };